module.exports = __webpack_public_path__ + "img/cannery-7.4221f963.jpg";